export const LAYOUT_EDITOR_TEMPLATE = 'layout_editor';

export const PAGE_BLOCK_TYPES = [
  { id: 'hero', label: 'Header-Banner' },
  { id: 'text', label: 'HTML/Text' },
  { id: 'image_text', label: 'Bild + Text' },
  { id: 'image', label: 'Bild/PDF' },
  { id: 'cta', label: 'Call-to-Action' },
  { id: 'faq', label: 'FAQ/Wissen' },
];

const DEFAULTS = {
  hero: {
    nl: {
      eyebrow: 'Horrenmaker',
      title: 'Nieuwe pagina',
      subtitle: 'Een sterke nieuwe pagina in de stijl van horrenmaker.nl.',
      button_text: 'Offerte aanvragen',
      button_link: '/offerte',
      image: '/scenes/hero-summer.webp',
    },
    de: {
      eyebrow: 'Horrenmaker',
      title: 'Neue Seite',
      subtitle: 'Eine starke neue Seite im Stil von horrenmaker.nl.',
      button_text: 'Angebot anfragen',
      button_link: '/offerte',
      image: '/scenes/hero-summer.webp',
    },
  },
  text: {
    nl: { title: 'Nieuwe sectie', html: '<p>Schrijf hier de inhoud van deze sectie.</p>' },
    de: { title: 'Neue Sektion', html: '<p>Schreibe hier den Inhalt dieser Sektion.</p>' },
  },
  image_text: {
    nl: { eyebrow: 'Advies', title: 'Beeld en verhaal', html: '<p>Combineer tekst met een passend beeld uit de mediapool.</p>', image: '' },
    de: { eyebrow: 'Beratung', title: 'Bild und Geschichte', html: '<p>Kombiniere Text mit einem passenden Bild aus dem Medienpool.</p>', image: '' },
  },
  image: {
    nl: { title: 'Media', image: '', alt: '', caption: '' },
    de: { title: 'Medien', image: '', alt: '', caption: '' },
  },
  cta: {
    nl: { eyebrow: 'Samen plannen', title: 'Klaar voor horren op maat?', text: 'Wij helpen je met advies, meten en montage.', button_text: 'Offerte aanvragen', button_link: '/offerte' },
    de: { eyebrow: 'Gemeinsam planen', title: 'Bereit fuer Insektenschutz nach Mass?', text: 'Wir helfen dir mit Beratung, Aufmass und Montage.', button_text: 'Angebot anfragen', button_link: '/offerte' },
  },
  faq: {
    nl: { title: 'Veelgestelde vragen', items: [{ q: 'Past dit bij mijn situatie?', a: 'Ja, wij stemmen de oplossing op jouw raam, deur of lichtschacht af.' }] },
    de: { title: 'Haeufige Fragen', items: [{ q: 'Passt das zu meiner Situation?', a: 'Ja, wir stimmen die Loesung auf dein Fenster, deine Tuer oder deinen Lichtschacht ab.' }] },
  },
};

export function getPageBlockLabel(type) {
  return PAGE_BLOCK_TYPES.find((item) => item.id === type)?.label || type;
}

export function createPageBlock(type = 'text') {
  const safeType = PAGE_BLOCK_TYPES.some((item) => item.id === type) ? type : 'text';
  return {
    id: `block-${safeType}-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`,
    type: safeType,
    enabled: true,
    layout: safeType === 'image_text' ? 'media-right' : 'default',
    tone: 'light',
    translations: JSON.parse(JSON.stringify(DEFAULTS[safeType] || DEFAULTS.text)),
  };
}

export function normalizePageBlocks(blocks) {
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return [createPageBlock('hero'), createPageBlock('text'), createPageBlock('cta')];
  }
  return blocks.map((block) => ({
    id: block.id || `block-${block.type || 'text'}-${Math.random().toString(16).slice(2, 8)}`,
    type: PAGE_BLOCK_TYPES.some((item) => item.id === block.type) ? block.type : 'text',
    enabled: block.enabled !== false,
    layout: block.layout || (block.type === 'image_text' ? 'media-right' : 'default'),
    tone: block.tone || 'light',
    translations: block.translations || JSON.parse(JSON.stringify(DEFAULTS[block.type || 'text'] || DEFAULTS.text)),
  }));
}

export function createLayoutEditorPage(seed = {}) {
  const id = seed.id || `page-${Date.now()}`;
  return {
    id,
    path: seed.path || '/neue-seite',
    template: LAYOUT_EDITOR_TEMPLATE,
    published: false,
    translations: {
      nl: { title: 'Nieuwe pagina', eyebrow: 'Informatie', excerpt: '' },
      de: { title: 'Neue Seite', eyebrow: 'Information', excerpt: '' },
      ...(seed.translations || {}),
    },
    blocks: normalizePageBlocks(seed.blocks),
    seo: {
      nl: { title: '', description: '', image: '', noindex: false },
      de: { title: '', description: '', image: '', noindex: false },
      ...(seed.seo || {}),
    },
  };
}
